import { useState, useEffect } from "react";
import { loadIcons } from "../../Utils/iconUtils";
import IconLoader from "../Common/IconLoader";

const LoadingSpinner = () => {
  const [Icons, setIcons] = useState({
    loading: true,
    VscLoading: null,
  });

  useEffect(() => {
    const loadIconsAsync = async () => {
      try {
        const loadedIcons = await loadIcons([
          { family: 'vsc', name: 'VscLoading' },
        ]);
        setIcons({ loading: false, ...loadedIcons });
      } catch (error) {
        console.error('Error loading icons:', error);
        setIcons(prev => ({ ...prev, loading: false }));
      }
    };

    loadIconsAsync();
  }, []);

  return (
    <div className="fixed left-0 top-0 z-[999] flex h-screen w-screen items-center justify-center bg-gray-300 bg-opacity-25">
      <div className="rounded-md bg-white p-4">
        <div className="flex items-center justify-center gap-4">
          {Icons.VscLoading ? (
            <Icons.VscLoading className="h-10 w-10 animate-spin text-plaved" />
          ) : (
            <IconLoader />
          )}
          <span className="ml- text-lg">Cargando...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
